var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdifWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 30,
    id: "ADIF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468 165",
    style: {
      enableBackground: "new 0 0 468 165"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Adif") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#003745;}\n\t.st1{fill:#00703c;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.6,105.9c-5.3,0-10-1.6-14.4-4.8c-5.1-3.6-7.7-8.4-7.7-14.5c0-5.3,2.2-9.8,6.5-13.5 c4.3-3.8,9.5-5.7,15.6-5.7c6.2,0,11.4,1.9,15.6,5.7c4.3,3.8,6.5,8.3,6.5,13.5c0,5.3-2.2,9.9-6.5,13.7 C223,104.1,217.7,105.9,211.6,105.9 M253.3,85.6c-0.1-7.3-4.2-13.5-12.5-18.6c-8.2-5.2-18.1-7.8-29.7-7.8c-11.7,0-21.7,2.6-30,7.9 c-8.3,5.2-12.5,11.4-12.5,18.7c0,7.4,4.1,13.7,12.4,19c8.3,5.2,18.2,7.8,29.9,7.8c7.7,0,14.9-1.2,21.5-3.6v2.3h21V85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.8,73.7h22.9c2,0,3.6,1.7,3.6,3.7v4.1c0,2.4-2,3.7-3.6,3.7h-22.9v22.4c0,2.1-1.7,3.7-3.7,3.7h-13.7 c-2,0-3.7-1.7-3.7-3.7V61c0-9.9,8.3-20,20.3-23.8c5.8-1.8,10.6-1.8,14.3-1.8H455v5.8l-11.9,0c-3.6,0-7.5,1.4-9.8,2.4 c-8.6,4-11.5,9.3-11.5,17.8V73.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.7,111.2h20.9V63.4c0-2-1.6-3.7-3.7-3.7h-13.5c-1.5,0-3.7,1.2-3.7,3.7V111.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.3,40.2c-3,0-5.6,0.7-7.7,2.1c-2.1,1.4-3.1,3.1-3.1,5.1c0,2,1,3.7,3.1,5.1c2.1,1.4,4.6,2,7.6,2 c3,0,5.5-0.7,7.6-2.1c2.1-1.4,3.1-3.1,3.1-5c0-2-1-3.7-3.1-5.1C378.7,40.9,376.2,40.2,373.3,40.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.4,32h-14.3c-2.3,0-3.7,1.9-3.7,3.7v26.9c-6.3-2.2-13.2-3.3-20.4-3.3c-11.7,0-21.7,2.6-30,7.9 c-8.2,5.2-12.4,11.4-12.4,18.7c0,7.3,4.2,13.6,12.5,18.9c8.3,5.2,18.3,7.7,30.1,7.7c11.6,0,21.5-2.6,29.6-7.7 c8.2-5.2,12.3-11.4,12.3-18.9V35.7C347.1,34,345.9,32,343.4,32 M320.7,99.9c-4.2,3.7-9.4,5.6-15.4,5.6c-6,0-11.2-1.9-15.5-5.6 c-4.2-3.8-6.4-8.4-6.4-13.7c0-5.3,2.1-9.9,6.4-13.6c4.3-3.8,9.4-5.7,15.4-5.7c6,0,11.2,1.9,15.4,5.7c4.3,3.7,6.5,8.3,6.5,13.6 C327.1,91.5,325,96.1,320.7,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78,18.4c1.9,1.4,25.6,20.6,60.2,63.9c4.6,5.8,9.1,12.8,9.4,17c0.6,7.1-6.7,13.1-19.4,17.7 c-8.4,3-41.8,15.5-65.1,23.9c6.5-8.7,13.1-18.6,19.2-29.4c21.5-38,23.7-49.3,20.7-58c-2.8-8.2-8.8-7.9-10.8-7.5 c1.8-0.3,7.9,0.6,9.1,8.9c1.5,10.4-4.7,19.7-35.7,59.6c-10.1,13-20.4,24.9-30,35c-10.1,1.3-30.9,0.8-19.1-31.7 c0.8-2.1,1.6-4.3,2.4-6.5c12.5-8.2,35.2-24.2,54.6-40.6c28.8-24.4,15.7-25,15.7-25s11.4,2.2-19.6,23.5C54.3,79.8,37.8,89,25,95.7 c13.5-33.6,30.2-68.5,32.8-72.8C62.5,15.5,69.6,12.3,78,18.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdifWordmark);
export default __webpack_public_path__ + "static/media/adif_wordmark.dfbb34824a09bda04f0ae0007d5f1654.svg";
export { ForwardRef as ReactComponent };